<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="90%" @click:outside="clickOutside">
      <template v-slot:activator="{ on, attrs }">
        <p id="usageFormAdd" v-bind="attrs" v-on="on" @click="updateItem"></p>
      </template>
      <v-card style="position: relative">
        <v-form
          ref="entryForm"
          @submit.prevent="submit"
          style="position: relative"
        >
          <v-card flat style="text-align: center; margin-bottom: 20px">
            <v-toolbar-title class="overline">
              <p style="font-size: 20px; margin: 0; font-weight: bold">
                Formulir Pemakaian
              </p>
            </v-toolbar-title>
          </v-card>

          <v-row no-gutters style="padding: 15px">
            <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <!-- <v-autocomplete
                    v-model="company"
                    :items="dropdownCompany"
                    item-text="name"
                    item-value="id"
                    return-object
                    outlined
                    :readonly="!isAdminHO"
                    :disabled="
                      getUserProfile.level.find(
                        ({ id }) => id === '1' || id === '29'
                      ) === undefined
                    "
                    style="margin: 0"
                  ></v-autocomplete> -->
                  <v-autocomplete
                    v-model="form.company"
                    :items="dropdownCompany"
                    item-text="name"
                    item-value="id"
                    return-object
                    outlined
                    style="margin: 0"
                  ></v-autocomplete>
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Lokasi Pemakaian
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.usage_location"
                    clearable
                    dense
                    outlined
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Rencana Pemakaian
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.planned_date"
                    clearable
                    dense
                    outlined
                    type="date"
                    name="date"
                    step="1"
                  />
                </v-col>
              </div>
            </v-col>
            <!-- <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tgl. Aktual
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-text-field
                    v-model="form.actual_date"
                    clearable
                    dense
                    outlined
                    type="date"
                    name="date"
                    step="1"
                  />
                </v-col>
              </div>
            </v-col> -->
            <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Qty Digunakan
                  </p>
                </v-col>
                <v-col cols="4" style="padding: 0">
                  <v-text-field
                    v-model="form.qty_used"
                    dense
                    outlined
                    type="number"
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="6" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0">
                  <v-textarea
                    v-model="form.description"
                    dense
                    auto-grow
                    outlined
                  />
                </v-col>
              </div>
            </v-col>
          </v-row>
          <div flat style="text-align: center">
            <!-- class="d-flex justify-center align-center" -->
            <v-btn
              style="width: 90%; margin-bottom: 15px"
              color="primary"
              type="submit"
            >
              simpan
            </v-btn>

            <v-btn
              icon
              style="position: absolute; top: 5px; right: 5px"
              x-small
              color="black"
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../services/buildType'
export default {
  props: ['assetDetail', 'selectedLot'],
  data() {
    return {
      asset: buildType.apiURL('asset'),
      eSanqua: buildType.apiURL('esanqua'),
      dialog: false,
      form: {
        company: null,
        usage_location: null,
        planned_date: null,
        // actual_date: null,
        description: null,
        qty_used: 0
      },
      purchaseDateRules: [],
      locationRules: [],
      totalLotRules: [],
      dropdownCompany: [],
      isAdminHO: false
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  watch: {},
  methods: {
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    submit() {
      // this.purchaseDateRules = [(v) => !!v || 'Required']
      // this.locationRules = [(v) => !!v || 'Required']
      // this.totalLotRules = [(v) => !!v || 'Required']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const newForm = {
        usage_location: this.form.usage_location,
        planned_date: this.form.planned_date,
        actual_date: this.form.actual_date,
        description: this.form.description,
        qty_used: this.form.qty_used,
        lot_id: this.selectedLot.id
      }
      if (this.form.company) {
        Object.assign(newForm, {
          company_id: Number(this.form.company.id),
          company_name: this.form.company.name
        })
      }
      console.log('newForm>>>', newForm)
      if (
        this.selectedLot.qty == null ||
        this.selectedLot.qty == '' ||
        this.selectedLot.qty == 0
      ) {
        return this.showMsgDialog('warning', 'Qty tidak tersedia', false)
      }
      if (
        this.form.qty_used == 0 ||
        this.form.qty_used == null ||
        this.form.qty_used == ''
      ) {
        return this.showMsgDialog(
          'warning',
          'Qty digunakan harus lebih dari 0',
          false
        )
      }
      if (Number(this.form.qty_used) > Number(this.selectedLot.qty)) {
        return this.showMsgDialog(
          'warning',
          'Qty digunakan tidak dapat melebih qty tersedia',
          false
        )
      }
      this.saveItem(newForm)
    },
    saveItem(form) {
      axios
        .post(`${this.asset}usage/save`, form)
        .then((res) => {
          console.log(res)
          if (res.data.status_code == '00') {
            window.open(
              `/asset-management/detail-pemakaian/${res.data.created_id}`,
              '_blank'
            )
            // this.$router.push(
            //   `/asset-management/detail-pemakaian/${res.data.created_id}`
            // )
            this.showMsgDialog('success', res.data.status_msg, false)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'error',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.$emit('loadPage')
          this.close()
        })
        .catch((err) => {
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    clickOutside() {},
    updateItem() {
      console.log('selectedLot', this.selectedLot)
      this.form.asset_id = this.assetDetail.id
      this.form.company = {
        id: Number(this.selectedLot.current_company_id),
        name: this.selectedLot.current_company_name
      }
      this.isAdminHO = this.getUserProfile.employee.company.plant_id === '6'
      // console.log(this.getDropdownPlant)
      this.getDropdownPlant()
    },
    getDropdownPlant() {
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          if (res.data.status_code == '00') {
            this.dropdownCompany = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    close() {
      this.form = {
        asset_id: '',
        location: null,
        lot_no: '',
        purchase_date: ''
      }
      this.dialog = false
    }
  }
}
</script>
<style lang="scss" scoped></style>
